import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { Spacings, Fonts } from '@styles/index';

const getStyling = (type) => {
  const styling = {
    filled: {
      Bg: 'var(--color-base-fill)',
      Text: 'var(--color-base-1)',
      paddingHorizontal: Spacings.SPACING_2B,
      fontSize: Fonts.H7
    },
    hollow: {
      Bg: 'var(--color-shadow)',
      Text: 'var(--color-text-primary)',
      paddingHorizontal: Spacings.SPACING_6,
      fontSize: Fonts.EXTRA_SMALL
    },
    transparent: {
      Bg: 'var(--color-base-1)',
      Text: 'var(--color-i-blue)',
      paddingHorizontal: Spacings.SPACING_0B,
      fontSize: Fonts.H7
    },
    live: {
      Bg: 'var(--color-i-red)',
      Text: 'var(--color-i-white)',
      paddingHorizontal: Spacings.SPACING_2B,
      fontSize: Fonts.H7
    },
    disabled: {
      Bg: 'var(--color-base-1)',
      Text: 'var(--color-text-secondary)',
      paddingHorizontal: Spacings.SPACING_0B,
      fontSize: Fonts.EXTRA_SMALL
    },
    discount: {
      Bg: 'var(--color-i-orange-16)',
      Text: 'var(--color-i-orange-1)',
      paddingHorizontal: Spacings.SPACING_2B,
      fontSize: Fonts.H7
    },
    alert: {
      Bg: 'var(--color-base-1)',
      Text: 'var(--color-i-red)',
      paddingHorizontal: Spacings.SPACING_0B,
      fontSize: Fonts.H7
    },
    success: {
      Bg: 'var(--color-i-green)',
      Text: 'var(--color-base-1)',
      paddingHorizontal: '10px',
      fontSize: Fonts.EXTRA_SMALL
    }
  };
  return styling[type];
};

const semiBold = ['filled', 'live', 'alert'];

const Tags = styled.span`
  background-color: ${({ type, bgColor }) => {
    return bgColor || getStyling(type)?.Bg;
  }};
  color: ${({ type }) => getStyling(type)?.Text};
  font-size: ${({ type }) => getStyling(type).fontSize};
  font-weight: ${({ type }) =>
    semiBold.includes(type) ? Fonts.SEMIBOLD : Fonts.BOLD};
  padding: ${({ type }) =>
    `${Spacings.SPACING_6} ${getStyling(type)?.paddingHorizontal}`};
  border-radius: ${Spacings.SPACING_1B};
  display: inline-block;
  text-transform: uppercase;
  line-height: 1;
`;

export default Tags;

Tags.propTypes = {
  type: PropTypes.oneOf([
    'filled',
    'hollow',
    'transparent',
    'live',
    'disabled',
    'discount',
    'alert',
    'success'
  ]),
  bgColor: PropTypes.string
};

Tags.defaultProps = {
  type: 'transparent',
  bgColor: null
};
